import { Component, HostListener } from '@angular/core';
import { VehicleState } from './Components/vehiclestate/vehiclestate.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [VehicleState]
})
export class AppRoot {
  windowWidth: number;

  constructor() {}

  ngOnInit() {
    this.windowWidth = window.innerWidth;
  }

  desktopSize(): boolean {
    return this.windowWidth > 768;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = window.innerWidth;
  }
}
